'use client';

import React from 'react';
import { PiSparkleFill } from 'react-icons/pi';
import getCategoryIcon from '../../utils/getCategoryIcon';
import { PublicCategoryDTO } from '../../models/event';

interface Props {
  categories: PublicCategoryDTO[];
  activeSlug?: string;
  onSelect: (slug: string | undefined) => void;
}

const CategoryFilterPills: React.FC<Props> = ({ categories, activeSlug, onSelect }) => {
  if (categories.length === 0) {
    return null;
  }

  const pillClass = (active: boolean) => (
    `flex-shrink-0 inline-flex items-center gap-1.5 md:gap-2 px-3.5 md:px-5 py-2 md:py-2.5 rounded-full border text-sm font-medium whitespace-nowrap transition-colors ${
      active
        ? 'bg-primary-500 text-white border-primary-500 shadow-sm'
        : 'bg-surface-base text-text-primary border-border-secondary hover:border-primary-300 hover:text-primary-500'
    }`
  );

  return (
    <nav aria-label="Categorías">
      <div className="flex gap-2 md:gap-2.5 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <button
          type="button"
          onClick={() => onSelect(undefined)}
          aria-pressed={!activeSlug}
          className={pillClass(!activeSlug)}
        >
          <PiSparkleFill className="text-base" />
          Todos
        </button>
        {categories.map((category) => {
          const Icon = getCategoryIcon(category.slug);
          const isActive = activeSlug === category.slug;
          return (
            <button
              key={category.slug}
              type="button"
              onClick={() => onSelect(category.slug)}
              aria-pressed={isActive}
              className={pillClass(isActive)}
            >
              <Icon className="text-base" />
              {category.name}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default CategoryFilterPills;
